import { useStep } from '../hooks/use-step'
import { type fullAgents } from '../utils/cards'

import { MeetYourNewAICollaborators } from './meet-your-new-ai/meet-your-new-ai'
import Plus from './plus/plus'
import { Proofreader } from './proofreader/proofreader'
import SuperhumanGo from './super-human-go/super-human-go'
import { UseAgentSkillsAnywhere } from './use-agent-skills-anywhere/use-agent-skills-anywhere'

import style from './main-content.module.scss'

const MainContent = ({ agents }: { agents: typeof fullAgents }) => {
  const { isLockedToGoTime } = useStep()
  if (isLockedToGoTime) return null
  return (
    <div className={style.mainContent}>
      <MeetYourNewAICollaborators />
      <SuperhumanGo />
      <Proofreader />
      <Plus agents={agents} />
      <UseAgentSkillsAnywhere />
    </div>
  )
}

export default MainContent
